import { Injectable, signal } from '@angular/core';

/** Shared UI state for the fixed analytics sidebar width toggle. */
@Injectable({ providedIn: 'root' })
export class WebAnalyticsUiService {
  readonly sidebarExpanded = signal(true);

  setSidebarExpanded(v: boolean): void {
    this.sidebarExpanded.set(v);
  }
}
